import { Component, Input, inject, OnInit, ChangeDetectorRef, input, ViewChild, TemplateRef } from "@angular/core";
import { CommonModule, AsyncPipe } from '@angular/common';
import { Akte_Patient } from './Akte.Patient';
import { Akte_Vertrag } from './Akte.Vertrag';
import {
  Tabs,
  TabList,
  Tab,
  TabPanel,
  TabContent
} from '@angular/aria/tabs';
import { Akte } from '../Api/DcoApi/Akte'
import { Auftrag } from '../Api/DcoApi/Auftraege'
import {RestClient, Rights, StatusRights, User} from '../Api/DcoApi/Client/RestClient'
import { OffcanvasComponent } from "./Controlls/offcanvas.component";
import { Splash } from "./Controlls/Splash";
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { Patient } from "../Api/DcoApi/Patient";
import { UserEdit } from "./Popups/UserEdit"
import { Notitzen } from "./Controlls/Notitzen";
import { FileList } from "./Controlls/FileList";
import { PflegegruppeSelect } from "./Controlls/PflegegruppeSelect";
import { Rueckabwicklung } from "./Controlls/Rueckabwicklung";
import { ArtikelEdit } from "./Popups/ArtikelEdit";
import { Notitz } from "../Api/DcoApi/Notitz";
import {EKVNummerMaskDirective, VNummerType} from "../Masks/EKVNummer";
import { ToDos } from "./Controlls/ToDos";
import { ToDo } from "../Api/DcoApi/AktenEintraege/ToDo";
import { ToastService } from "./Services/Toasts/ToastService";
import { Data } from "@angular/router";
import { ConfirmDialog } from "./Popups/ConfirmDialog";
import { IsSpezialUserDirective, IsWelcomeCallDirective,IsManagementDirective } from "../Admin/AdminGuard";
import {PhoneCall} from '../Componente/PhoneCall';
import {AuthorizeDirective} from '../Directives/AuthorizationDirective';
import {RotateDevice} from './Popups/rotate-device/rotate-device';
import {AdminCard} from '../Admin/Controlls/Sonstige/AdminCard';
import {DataGridView, DataGridViewCollumn, Types} from '../Componente/DataGridView';
import {VersandStepper} from '../Componente/versand-stepper/versand-stepper';


@Component({
  imports: [
    CommonModule,
    Akte_Patient,
    Akte_Vertrag,
    Tabs,
    TabList,
    Tab,
    TabPanel,
    TabContent,
    OffcanvasComponent, AuthorizeDirective,
    Splash, PhoneCall,
    FormsModule, Notitzen, FileList, PflegegruppeSelect, Rueckabwicklung, EKVNummerMaskDirective, IsManagementDirective, ToDos, IsWelcomeCallDirective, IsSpezialUserDirective, AdminCard, DataGridView, DataGridViewCollumn, VersandStepper, FormsModule
  ],
  selector: 'Akte-Main',
  templateUrl: './Akte.Main.html',
  standalone: true,
  styleUrl: './Akte.Main.css'
})
export class Akte_Main implements OnInit {

  @Input() VersicherungsNr?: string | null = null;
  @Input() VertragID?: number | null = null;
  toastService: ToastService = inject(ToastService);
  public ApiUser = User;
  Client: RestClient;
  Akte: Akte | null = null;
  OffenerAuftrag: Auftrag | null = null;
  User = User;

  IsLoading: boolean = true;
  NewOrderPG: number = 52;

  Notitzen: Notitz[] = [];
  ToDos: ToDo[] = [];

  private modalService = inject(NgbModal);
  get IsAddDialog(): boolean {
    return this.Akte == null;
  }
  constructor(private cdr: ChangeDetectorRef) {
    this.Client = new RestClient();
  }

  SelectAuftrag(auftrag: Auftrag) {
    console.log(auftrag);
    this.OffenerAuftrag = auftrag;
    this.CanSendMip();
    this.MipAlreadySend();
    this.cdr.detectChanges();
  }

  MipAllowed: boolean = false;
  mipAlreadySend: boolean = false;

  get OrderStep() : number
  {
      if(!this.OffenerAuftrag)
        return 0;

    if (this.OffenerAuftrag.status >= 900)
      return 5;

    if (this.OffenerAuftrag.status >= 800)
      return 4.5;

    if (this.OffenerAuftrag.status >= 100)
      return 3.5;

    if (this.OffenerAuftrag.status >= 40)
      return 2.5;

    if (this.OffenerAuftrag.status > 0)
      return 1.5;



    return 0.5;
  }

  handleAuftragChange(auftrag: Auftrag | null): void {

    this.OffenerAuftrag = auftrag;

    // Hier kannst du weitere Logik ausführen
    if (auftrag && this.Akte) {
      this.Akte.aktiveAuftraege = this.Akte?.aktiveAuftraege?.filter(o => o.key != auftrag.key) ?? [];
      this.Akte.vergangeneAuftraege = this.Akte?.vergangeneAuftraege?.filter(o => o.key != auftrag.key) ?? []
      if (auftrag.status == 999) {
        this.Akte.vergangeneAuftraege.push(auftrag);
      }
      else {
        this.Akte.aktiveAuftraege.push(auftrag);
      }

    }

    this.CanSendMip();
    this.MipAlreadySend();
  }

  async ngOnInit() {

    console.log(`Akte Inited: Nr: ${this.VersicherungsNr}`);

    if (this.VersicherungsNr != null) {

      await this.OpenAkte();
      //console.log(this.Akte);

      if (this.Akte != null && this.VertragID != null) {
        this.OffenerAuftrag = this.Akte.aktiveAuftraege.find(o => o.key == this.VertragID) ?? this.Akte.vergangeneAuftraege.find(o => o.key == this.VertragID) ?? null;
        this.CanSendMip();
        this.MipAlreadySend();
      }

    }

    this.IsLoading = false;
    this.cdr.detectChanges();
  }

  async AddNewOrder() {
    try {
      var auftrag = await this.Client.Post<Auftrag, Auftrag>(`/Backend/Api/V2/Akte/${this.VersicherungsNr?.replaceAll('_', '')}/Auftrag/Create`, { pflegegruppe: this.NewOrderPG, genehmigung: { hilfsmittelnummer: "52.40.01.1132" } } as Auftrag);
      await this.OpenAkte();
      this.SelectAuftrag(auftrag);
    }
    catch {
      this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
    }
  }


  async pruefePatientAndReloadIfNeeded(patient: Patient | null) {
    if (patient) {
      if (this.Akte?.patient?.versicherungsnummer != patient.versicherungsnummer) {
        this.VersicherungsNr = patient.versicherungsnummer;
        await this.OpenAkte()
      } else {
        this.Akte.patient = patient;
      }
    }
    this.cdr.detectChanges();
  }


  async CheckVersicherungsNrOrAddUser() {
    var patient: Patient | null = null;

    try {
      patient = await this.Client.Get<Patient>(`/Backend/Api/V2/Akte/${this.VersicherungsNr?.replaceAll('_', '')}/Patient`)
    } catch { }
    if (patient == null) {
      var modal = this.modalService.open(UserEdit);
      modal.componentInstance.IsNew = true;
      debugger;
      modal.componentInstance.patient.versicherungsnummer = this.VersicherungsNr?.replaceAll('_','');

      if(this.VNummerTypeSelect == VNummerType.Company)
      {
        modal.componentInstance.patient.isCompany = true;
      }
      else if(this.VNummerTypeSelect == VNummerType.PKV)
      {
        modal.componentInstance.patient.gesetzlichVersichert = false;
      }

      modal.closed.subscribe({
        next: async (config) => {
           patient = config as Patient;
          //Post Request To Create
          if (patient != null) {
            this.VersicherungsNr = patient.versicherungsnummer;
            await this.OpenAkte();

            this.cdr.detectChanges();
          }
        },
        error: (err) => {

        },
      })
    }
    else {
      await this.OpenAkte();
      this.cdr.detectChanges();
    }
  }

  async RefreshOrder() {

    var modal = this.modalService.open(ConfirmDialog);
    modal.update({ size: 'Dialog' });
    modal.componentInstance.Text = "Möchten Sie wirklich die Akte neu anlegen?";
    modal.closed.subscribe(async b => {
      if (b && this.OffenerAuftrag != null) {
        try {
          var auftrag = await this.Client.Get<Auftrag>(`/Backend/Api/V2/Akte/${this.VersicherungsNr?.replaceAll('_', '')}/Auftrag/${this.OffenerAuftrag.key}/CopyAndReplace`);
          await this.OpenAkte();
          this.SelectAuftrag(auftrag);
        }catch {
          this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
        }

      }
    });

  }

  async OpenArtikelEdit() {
    if (this.OffenerAuftrag != null && this.Akte?.patient != null) {
      var modal = this.modalService.open(ArtikelEdit);
      modal.componentInstance.VersichertenNR = this.Akte?.patient.versicherungsnummer;
      modal.componentInstance.Auftrag = this.OffenerAuftrag;
    }
  }

  RotateDevice(){
    var modal = this.modalService.open(RotateDevice);
    modal.update({ size: 'Dialog' });
    modal.componentInstance.Auftrag = this.OffenerAuftrag?.key;
    modal.closed.subscribe(async b => {
      if (b && this.OffenerAuftrag != null) {
        try {
          var auftrag = await this.Client.Get<Auftrag>(`/Backend/Api/V2/Akte/${this.VersicherungsNr?.replaceAll('_', '')}/Auftrag/${this.OffenerAuftrag.key}`);
          await this.OpenAkte();
          this.SelectAuftrag(auftrag);
        }
        catch {
          this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
        }
      }
    });
  }

  async SendLeitstelleEdit() {
    try {
      if (this.OffenerAuftrag != null && this.OffenerAuftrag.leitstelle?.versand != null && this.OffenerAuftrag.leitstelle?.versand != undefined) {
        var res =await this.Client.Get<Data>(`/ReSendNotfallPlan/${this.OffenerAuftrag.key}`);
        if(res != null)
          this.toastService.show({ template: this.successVerTpl, classname: 'bg-success text-light show', delay: 10000 })
      }
      else if (this.OffenerAuftrag != null) {
        var res = await this.Client.Get<Data>(`/SendNotfallPlan/${this.OffenerAuftrag.key}`);
        if(res != null && res != undefined) {
          this.toastService.show({template: this.successVerTpl, classname: 'bg-success text-light show', delay: 10000})
          this.OffenerAuftrag.leitstelle.versand = new Date();
        }
        else
          this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
      }
    }
    catch {
      this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
    }

    this.cdr.detectChanges();
  }

  async SendLeitstelleRevoke() {
    try {
      if (this.OffenerAuftrag != null && this.OffenerAuftrag.leitstelle?.versand != null && this.OffenerAuftrag.leitstelle?.versand != undefined) {
        await this.Client.Get<Auftrag>(`/RevokeNotfallPlan/${this.OffenerAuftrag.key}`);
        this.OffenerAuftrag.geraet.angemeldet = false;
        this.toastService.show({ template: this.successVerTpl, classname: 'bg-success text-light show', delay: 10000 })
      }
      else
        this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
    }
    catch {
      this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
    }
    this.cdr.detectChanges();
  }

  async CanSendMip() {



    if (this.OffenerAuftrag != null ) {
      try {
        var Cansend = await this.Client.Get<boolean>(`/CanUseMip/${this.OffenerAuftrag.key}`);
        if (Cansend) {
          this.MipAllowed = Cansend;
          this.cdr.detectChanges();
          return;
        }
      } catch {

      }
    }
    this.MipAllowed = false;
    this.cdr.detectChanges();

  }

  async MipAlreadySend() {
    if (this.OffenerAuftrag != null) {
      try {
        var Cansend = await this.Client.Get<boolean>(`/MipAlreadySend/${this.OffenerAuftrag.key}`);
        if (Cansend) {
          this.mipAlreadySend = Cansend;
          this.cdr.detectChanges();
          return;
        }
      } catch {
        //this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
      }
    }
    this.mipAlreadySend = false;
    this.cdr.detectChanges();

  }

  async ResendMip() {

    if (this.mipAlreadySend) {
      alert("Antrag wurde bereits versendet!");
      return;
    }

    if (this.OffenerAuftrag != null) {
      try {
        var sendDate = await this.Client.Get<Date>(`/Mip/${this.OffenerAuftrag.key}`);
        if (sendDate) {
          this.OffenerAuftrag.ekv.versand = new Date(sendDate);
          this.toastService.show({ template: this.successVerTpl, classname: 'bg-success text-light show', delay: 10000 });
        }
        else
          this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
      } catch {
        this.toastService.show({ template: this.FaildVerTpl, classname: 'bg-danger text-light show', delay: 10000 });
      }
    }
    this.cdr.detectChanges();
  }

  async OpenAkte() {
    this.Akte = await this.Client.Get<Akte>(`/Backend/Api/V2/Akte/${this.VersicherungsNr?.replaceAll('_', '')}`);
    if (this.Akte && this.Akte != null && this.Akte.patient && this.Akte.patient != null) {
      this.Notitzen = await this.Client.Get<Notitz[]>(`/Backend/Api/V2/Akte/${this.Akte.patient.versicherungsnummer}/Notebook`);
      this.ToDos = await this.Client.Get<ToDo[]>(`/Backend/Api/V2/Akte/${this.Akte.patient.versicherungsnummer}/ToDo`);
    }
    this.NewOrderPG = 52;
  }

  get openTodosCount(): number {
    return this.ToDos ? this.ToDos.filter(t => !t.erledigt).length : 0;
  }
  @ViewChild('successVerTpl') public successVerTpl!: TemplateRef<any>;
  @ViewChild('FaildVerTpl') public FaildVerTpl!: TemplateRef<any>;

  protected readonly Rights = Rights;
  protected readonly StatusRights = StatusRights;
  protected readonly Types = Types;
  protected readonly VNummerType = VNummerType;
  protected _VNummerTypeSelect :VNummerType = VNummerType.GKV;

  protected get VNummerTypeSelect()
  {
    return this._VNummerTypeSelect;
  }

  protected set VNummerTypeSelect(value:VNummerType)
  {
    this.VersicherungsNr = '';
    this.cdr.detectChanges();
    this._VNummerTypeSelect = value;

  }

  protected get VNummerEnabeld()
  {
    if(this.VNummerTypeSelect === VNummerType.Company)
      return false;

    if(this.VNummerTypeSelect === VNummerType.GKV)
      return true;
    else
      return false;
  }
}
